import { BaseComponent } from '@components/base.component';
import { Component, Input, OnInit } from '@angular/core';
import { BasketballMapFce, Team } from '@interfaces/match-data.interface';
import { ClientService } from '@services/client.service';
import { SourceId } from '@interfaces/source.interface';
import { toPairs } from 'lodash-es';
import SPORT_CONFIG from '@config/sport.config';

@Component({
    selector: 'app-timeline-basketball',
    templateUrl: './basketball-timeline.component.html',
    styleUrls: ['./basketball-timeline.component.scss'],
})
export class BasketballTimelineComponent extends BaseComponent implements OnInit {
    @Input() data: BasketballMapFce;
    @Input() sportName: string;
    @Input() sportId: number;
    @Input() home: Team | null = null;
    @Input() away: Team | null = null;

    public isUnknown = false;

    icons = {
        endperiod: 'fa fa-bell',
        stoppage: 'fa fa-pause-circle',
        review: 'fa fa-video-camera',
    };

    constructor(private client: ClientService) {
        super();
    }

    ngOnInit(): void {
        // console.log(`${this.sportName} data`, _.toPairs(this.data));

        this.isUnknown = Object.values(this.data)[0]!.some(
            (value: Record<string, any>) => value.source_id === SourceId.BETSAPI
        );
    }

    get actions(): [string, Record<string, any>[]][] {
        return toPairs(this.data);
    }

    get color(): string {
        return this.client.has('colors', 'icons') || 'black';
    }

    public participant = (qualifier: string): Team | null => {
        if (qualifier === 'home') {
            return this.home;
        }

        if (qualifier === 'away') {
            return this.away;
        }

        return null;
    };

    public hasIcon(action: Record<string, any>): boolean {
        return this.icons[action.type as keyof typeof this.icons] !== undefined;
    }

    public getIcon(action: Record<string, any>): string | null {
        return this.icons[action.type as keyof typeof this.icons] ?? null;
    }

    isTypeUnknown(type: string): boolean {
        return (
            this.isUnknown &&
            (type === SPORT_CONFIG.timeline.eventTypes.lineupchange ||
                type === SPORT_CONFIG.timeline.eventTypes.opentip ||
                type === SPORT_CONFIG.timeline.eventTypes.shootingfoul ||
                type === SPORT_CONFIG.timeline.eventTypes.freethrowmade ||
                type === SPORT_CONFIG.timeline.eventTypes.freethrowmiss ||
                type === SPORT_CONFIG.timeline.eventTypes.threepointmiss ||
                type === SPORT_CONFIG.timeline.eventTypes.twopointmiss ||
                type === SPORT_CONFIG.timeline.eventTypes.threepointmade ||
                type === SPORT_CONFIG.timeline.eventTypes.twopointmade ||
                type === SPORT_CONFIG.timeline.eventTypes.personalfoul ||
                type === SPORT_CONFIG.timeline.eventTypes.kickball ||
                type === SPORT_CONFIG.timeline.eventTypes.teamtimeout ||
                type === SPORT_CONFIG.timeline.eventTypes.review ||
                type === SPORT_CONFIG.timeline.eventTypes.jumpball ||
                type === SPORT_CONFIG.timeline.eventTypes.stoppage ||
                type === SPORT_CONFIG.timeline.eventTypes.endperiod ||
                type === SPORT_CONFIG.timeline.eventTypes.technicalfoulnonunsportsmanlike ||
                type === SPORT_CONFIG.timeline.eventTypes.offensivefoul ||
                type === SPORT_CONFIG.timeline.eventTypes.technicalfoul ||
                type === SPORT_CONFIG.timeline.eventTypes.delay ||
                type === SPORT_CONFIG.timeline.eventTypes.challengetimeout ||
                type === SPORT_CONFIG.timeline.eventTypes.defensivegoaltending ||
                type === SPORT_CONFIG.timeline.eventTypes.flagrantone ||
                type === SPORT_CONFIG.timeline.eventTypes.clearpathfoul ||
                type === SPORT_CONFIG.timeline.eventTypes.ejection ||
                type === SPORT_CONFIG.timeline.eventTypes.doublelane ||
                type === SPORT_CONFIG.timeline.eventTypes.flagranttwo ||
                type === SPORT_CONFIG.timeline.eventTypes.jumpballviolation)
        );
    }

    isTypeText(_type: string): boolean {
        return false;
    }

    isActionCollapsible(action: BasketballMapFce): boolean {
        return (action?.players?.length ?? 0) > 0;
    }
}
